function usePCMvisualiser(canvasElement) {
  const SAMPLE_BUFFER = [];
  const MAX_SAMPLES = 60 * 8;

  const processSignal = (samples) => {
    const average = samples.reduce((a, c) => a + c) / samples.length;
    const value = average; // Average freq here
    const time = Date.now();
    SAMPLE_BUFFER.push({ value, time });

    if (SAMPLE_BUFFER.length > MAX_SAMPLES) {
      SAMPLE_BUFFER.shift();
    }

    const dataStats = analyzeData(SAMPLE_BUFFER);
    drawGraph(dataStats);
  };
  const analyzeData = (samples) => {
    // Get the mean average value of the samples
    const average = samples.map((sample) => sample.value).reduce((a, c) => a + c) / samples.length;

    // Find the lowest and highest sample values in the data
    // Used for both calculating bpm and fitting the graph in the canvas
    let min = samples[0].value;
    let max = samples[0].value;

    samples.forEach((sample) => {
      if (sample.value > max) {
        max = sample.value;
      }
      if (sample.value < min) {
        min = sample.value;
      }
    });

    // The range of the change in values
    // For a good measurement it should be between  ~ 0.002 - 0.02
    const range = max - min;

    const crossings = getAverageCrossings(samples, average);
    return {
      average,
      min,
      max,
      range,
      crossings,
    };
  };

  const getAverageCrossings = (samples, average) => {
    // Get each sample at points where the graph has crossed below the average level
    // These are visible as the rising edges that pass the midpoint of the graph
    const crossingsSamples = [];
    let previousSample = samples[0]; // Avoid if statement in loop

    samples.forEach((currentSample) => {
      // Check if next sample has gone below average.
      if (currentSample.value < average && previousSample.value > average) {
        crossingsSamples.push(currentSample);
      }

      previousSample = currentSample;
    });

    return crossingsSamples;
  };
  let canvasResized = false;
  const resizeCanvas = (canvas) => {
    canvas.width = canvas.parentElement.clientWidth;
    canvas.height = canvas.parentElement.clientHeight;
    canvasResized = true;
  };
  const drawGraph = (dataStats) => {
    if (!canvasElement) return;
    if (!canvasResized) resizeCanvas(canvasElement);

    const canvas = canvasElement;
    const ctx = canvas.getContext('2d');
    // Scaling of sample window to the graph width
    const xScaling = canvas.width / MAX_SAMPLES;
    // Set offset based on number of samples, so the graph runs from the right edge to the left
    const xOffset = (MAX_SAMPLES - SAMPLE_BUFFER.length) * xScaling;

    ctx.lineWidth = 5;
    ctx.strokeStyle = '#2ed4bf';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.beginPath();

    const maxHeight = canvas.height - ctx.lineWidth * 2;
    let previousY = 0;
    SAMPLE_BUFFER.forEach((sample, i) => {
      const x = xScaling * i + xOffset;

      let y = ctx.lineWidth;

      if (sample.value !== 0) {
        y =
          (maxHeight * (sample.value - dataStats.min)) / (dataStats.max - dataStats.min) +
          ctx.lineWidth;
      }

      if (y != previousY) {
        ctx.lineTo(x, y);
      }

      previousY = y;
    });

    ctx.stroke();
  };

  return {
    processSignal,
  };
}

export default usePCMvisualiser;
